import moment from "moment";

export const sortTypes = {
    asc: "asc",
    desc: "desc"
}

const sortArrByObjKeyStringValue = (key, order) => (a, b) => {
    const sortOrder = order.toLowerCase() === "asc";
    key = key.toLowerCase();

    console.log({key});
    console.log({a});
    console.log({b});

    if (a[key] < b[key]) {
        return sortOrder ? -1 : 1;
    }

    if (a[key] > b[key]) {
        return sortOrder ? 1 : -1;
    }

    return 0;
}

export const defaultOnSortColumnHandler = (fieldName, sortOrder, data, setData, setSortType) => {
    
    if (fieldName.includes(".")) {
        console.warn("You should use another function for inner object fields");
        return false;
    }

    const sortFunc = sortArrByObjKeyStringValue(fieldName, sortOrder);
    let localLocations = [];

    switch (fieldName){
        case 'dob':
            const sortedByDate = data.map(patient => ({ ...patient, dob: Date.parse(patient.dob) }));
            localLocations = [...sortedByDate].sort(sortFunc).map(patient => ({ ...patient, dob: moment(new Date(patient.dob)).format("l") }));
            break;

        case 'location':
            console.log({data});
            const d = data.sort((a, b) => {
                if (!a.location){
                    return 0;
                }
                if (!b.location){
                   return 0;
                }

                const nameA = a.location.room_name.toUpperCase(); // ignore upper and lowercase
                const nameB = b.location.room_name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return sortOrder ? -1 : 1;
                }
                if (nameA > nameB) {
                    return sortOrder ? 1 : -1;
                }

                // names must be equal
                return 0;
            }).map(sortedLocation => ({...sortedLocation}));
            console.log({d});
            localLocations = d;
            break;

        default:
            localLocations = [...data].sort(sortFunc);
    }

    console.log({sortOrder});
    setData(localLocations);
    setSortType(sortOrder === sortTypes.asc ? sortTypes.desc : sortTypes.asc);
}